import React from 'react';
import { getDomainConfig } from '../config';
import './AboutPage.css';

function AboutPage() {
  const config = getDomainConfig();

  return (
    <div className="about-page">
      <div className="about-hero">
        <h1>About {config.name}</h1>
        <p className="subtitle">{config.tagline}</p>
      </div>

      <div className="about-content">
        <section className="about-section">
          <h2>Who We Are</h2>
          <p>
            {config.name} is a leading provider of {config.tagline.toLowerCase()}.
            We connect industrial buyers with top-quality suppliers and manufacturers,
            offering an extensive catalog of products tailored to your specific needs.
          </p>
          <p>
            Our platform serves thousands of businesses across various industries,
            providing access to millions of industrial products from verified suppliers.
          </p>
        </section>

        <section className="about-section">
          <h2>Our Mission</h2>
          <p>
            To simplify industrial procurement by providing a comprehensive, easy-to-navigate
            platform that connects buyers with the products and suppliers they need.
          </p>
        </section>

        <section className="about-section">
          <h2>Why Choose {config.name}?</h2>
          <div className="features-grid">
            <div className="feature">
              <h3>Extensive Catalog</h3>
              <p>Access to hundreds of thousands of products across multiple categories</p>
            </div>
            <div className="feature">
              <h3>Verified Suppliers</h3>
              <p>All suppliers are carefully vetted to ensure quality and reliability</p>
            </div>
            <div className="feature">
              <h3>Easy Search</h3>
              <p>Find exactly what you need with our advanced search and filtering</p>
            </div>
            <div className="feature">
              <h3>Expert Support</h3>
              <p>Our team is ready to help you find the right products for your needs</p>
            </div>
          </div>
        </section>

        <section className="about-section">
          <h2>Our Commitment</h2>
          <p>
            We are committed to providing the best possible experience for our customers.
            Whether you're looking for a single component or planning a large-scale procurement,
            {config.name} is here to help you succeed.
          </p>
        </section>
      </div>
    </div>
  );
}

export default AboutPage;
